import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import * as CryptoJS from "crypto-js"
import { GlobalHelper } from "../../indexImports"
import { Log } from "./log"

class LoggerService {

    static async LogRequest(payload: Log): Promise<void> {


        try {
            const logSecretKey = AppContext.getOptions().logSecretKey
            if (!logSecretKey) {
                return
            }

            const deviceType = GlobalHelper.isMobile() ? "Mobile Device" : "Desktop Device"    
            const browser = navigator.userAgent
            const deviceDimensions = `${window.innerWidth} x ${window.innerHeight}`

            payload.logBody["deviceType"] = deviceType
            payload.logBody["browser"] = browser
            payload.logBody["deviceDimensions"] = deviceDimensions

            const payloadJson = JSON.stringify(payload)
            const hmac = CryptoJS.HmacSHA256(payloadJson, logSecretKey).toString(CryptoJS.enc.Hex)            
            const url = `/api/logs?signature=${hmac}`
            const blob = new Blob([JSON.stringify(payload)], {type : "application/json; charset=UTF-8"})
            const success = navigator.sendBeacon(url, blob)
            if (!success) {
                console.error("Failed to send data using Beacon API")
            }
        } catch (error) {
            console.error("Error sending data using Beacon API:", error)
        }
    }
}

export default LoggerService


// WEBPACK FOOTER //
// ./src/state/logger/LoggerService.ts